import React from "react";
import ChatInputBlock from "../../Organisms/ChatInputBlock";
import ChatInputInnerBlock from "../../Molecules/ChatInputInnerBlock";
import TextArea from "../../Atoms/TextArea";
import ButtonSender from "../../Atoms/ButtonSender";

import { ArrowUp } from 'lucide-react';

const ChatInput = ({
  textareaHeight,
  handleInput,
  handleKeyDown,
  message,
  handleSendMessage,
  changeIcon,
  iconSendButton,
  t,
  isSending = false,
  thinkingMessage = "",
}) => {
  return (
    <ChatInputBlock>
      <ChatInputInnerBlock>
        <TextArea
          placeholder={thinkingMessage || "Digite sua mensagem aqui..."}
          containerStyle={{
            flex: 1,
            padding: 0,
            gap: 0,
          }}
          textAreaStyle={{
            height: `${textareaHeight}px`,
            minHeight: "20px",
            border: "none",
            resize: "none",
            overflowY: "hidden",
            padding: 0,
            lineHeight: "20px",
            marginRight: "12px",
          }}
          value={message}
          onInput={handleInput}
          onKeyDown={handleKeyDown}
          disabled={isSending}
        />
        <ButtonSender
          id="button-sender"
          disabled={isSending}
          onClick={() => {
            if (isSending) return;
            handleSendMessage();
            changeIcon();
          }}
        >
          <div className="p-1" style={{color:"#52525C"}}>
            <ArrowUp />
          </div>
        </ButtonSender>
      </ChatInputInnerBlock>
    </ChatInputBlock>
  );
};

export default ChatInput;
